import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ViewChild,
  OnChanges
} from '@angular/core'
import { CpmService } from '../../service/cpm.service'
import { environment } from '../../../environments/environment'
import { DomSanitizer } from '@angular/platform-browser'
import { BsModalService, BsModalRef } from 'ngx-bootstrap'
import { CrmContinueActionComponent } from '../crm-continue-action/crm-continue-action.component'
import { Subscription } from '../../../../node_modules/rxjs/Subscription'
import { StoreService } from 'app/service/store.service'
import { ActivatedRoute } from '../../../../node_modules/@angular/router';
@Component({
  selector: 'app-output-case',
  templateUrl: './output-case.component.html',
  styleUrls: ['./output-case.component.scss']
})
export class OutputCaseComponent implements OnInit, OnChanges {
  @Input() caseId
  @ViewChild('template') template: TemplateRef<any>
  @ViewChild('continueActionComponent')
  continueActionComponent: CrmContinueActionComponent

  modalRef: BsModalRef

  crmCaseId: Number
  securitySymbol: String
  meetingObjective: String
  summary: String
  caseStatus: String
  continueCaseIdString: String
  continueCaseIdNumber: Number
  jointDepartmentFlag: String
  meetingDate: Date
  caseType: String
  continueDepartment: String
  companyNameThai: String

  setAttendees: Array<Object> = []
  companyAttendees: Array<Object> = []
  otherAttendee: String
  serviceTime: String

  continueAction: Array<Object> = []

  oldPresentationFile = null
  oldFactsheetFile = null
  oldMemoFile = null

  iframeSource

  symbol
  showPage = false
  subscription: Subscription
  constructor(
    private cpmService: CpmService,
    private modalService: BsModalService,
    private sanitizer: DomSanitizer,
    private store: StoreService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    const { caseId } = this.activatedRoute.snapshot.params
    if (caseId !== undefined && caseId !== 'null' && caseId !== null) {
      this.caseId = caseId
      this.initialData()
    }
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(
        response => {
          if (!response) {
            return
          }
          this.setSymbol(response['securitySymbol'])
        },
        error => { }
      )
  }
  ngOnChanges() {
    this.initialData()
  }

  async initialData() {
    await this.getCrmCaseById(this.caseId)
    await this.getContinueCaseIdString()
  }

  getContinueCaseIdString() {
    if (this.continueCaseIdNumber === undefined) {
      return
    }
    this.cpmService
      .getCrmCaseById(this.continueCaseIdNumber['id'])
      .subscribe(continueCrmCase => {
        this.continueCaseIdString = continueCrmCase.caseId
      })
  }

  getCrmCaseById(id) {
    if (id === 'null') {
      this.showPage = false
    } else {
      this.showPage = true
    }
    if (id) {
      this.cpmService.getCrmCaseById(id).subscribe(
        crmCase => {
          this.symbol = crmCase.securitySymbol
          this.crmCaseId = crmCase.caseId
          this.caseType = crmCase.typeDescription
          this.continueCaseIdNumber = crmCase
          this.meetingDate = crmCase.meetingDate
          this.securitySymbol = crmCase.securitySymbol
          this.meetingObjective = crmCase.meetingObjective
          this.summary = crmCase.summary
          this.caseStatus = crmCase.caseStatus
          this.jointDepartmentFlag =
            crmCase.jointDepartmentFlag === 'Y' ? 'Yes' : 'No'
          this.oldPresentationFile = crmCase.presentationFile
          this.oldFactsheetFile = crmCase.factsheetFile
          this.oldMemoFile = crmCase.memoFile
          this.setAttendees = crmCase.setAttendee
          this.companyAttendees = crmCase.companyAttendee
          this.otherAttendee = crmCase.otherAttendee
          if (crmCase.serviceStartTime && crmCase.serviceEndTime) {
            this.serviceTime = crmCase.serviceStartTime + ' - ' + crmCase.serviceEndTime
          } else {
            this.serviceTime = null
          }
          this.continueAction = crmCase.continueAction
          this.getDepartmentWithAEName(
            crmCase.securitySymbol,
            crmCase.continueDepartment
          )
          this.companyNameThai = crmCase.companyNameThai
          this.continueActionSetting()
          this.scrollTo()
        },
        err => { }
      )
    }
  }

  getDepartmentWithAEName(securitySymbol, department) {
    this.cpmService.getAEList(securitySymbol).then(thisSymbolAeList => {
      const foundElement = thisSymbolAeList.find(
        e => e['department'] === department
      )
      if (foundElement) {
        this.continueDepartment = `${department} ${
          foundElement['firstNameThai']
          } ${foundElement['lastNameThai']}`
      }
    })
  }

  continueActionSetting(): void {
    this.continueActionComponent.continueActions = this.continueAction
    this.continueActionComponent.disableTextArea = true
    this.continueActionComponent.initial()
  }

  openModal(template: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-lg' })
    )
  }

  previewFile(fileForPreview): void {
    this.openModal(this.template)
    switch (fileForPreview) {
      case 'oldPresentationFile': {
        this.oldPresentation(this.caseId)
        break
      }
      case 'oldFactsheetFile': {
        this.oldFactsheet(this.caseId)
        break
      }
      case 'oldMemoFile': {
        this.oldMemo(this.caseId)
        break
      }
    }
  }

  closeModal(): void {
    this.modalRef.hide()
  }

  closeModalWithFileTypeCondition(arrayContainsFileType): void {
    setTimeout(
      function (modal) {
        if (!arrayContainsFileType) {
          setTimeout(modal.hide, 200)
        }
      },
      200,
      this.modalRef
    )
  }

  oldPresentation(id): void {
    this.iframeSource = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank')
    const array = this.oldPresentationFile.split('.')
    const openableFormat = ['jpg', 'gif', 'pdf', 'png'];
    const arrayContainsFileType = (openableFormat.indexOf(array[array.length - 1].toLowerCase()) > -1);
    this.iframeSource = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.cpmBaseUrl}/download?type=crm_presentation&id=${id}`
    )
    this.closeModalWithFileTypeCondition(arrayContainsFileType)
  }

  oldFactsheet(caseId): void {
    this.iframeSource = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank')
    const array = this.oldFactsheetFile.split('.')
    const openableFormat = ['jpg', 'gif', 'pdf', 'png'];
    const arrayContainsFileType = (openableFormat.indexOf(array[array.length - 1].toLowerCase()) > -1);
    this.iframeSource = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.cpmBaseUrl}/download?type=crm_factsheet&id=${caseId}`
    )
    this.closeModalWithFileTypeCondition(arrayContainsFileType)
  }

  oldMemo(caseId): void {
    this.iframeSource = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank')
    const array = this.oldMemoFile.split('.')
    const openableFormat = ['jpg', 'gif', 'pdf', 'png'];
    const arrayContainsFileType = (openableFormat.indexOf(array[array.length - 1].toLowerCase()) > -1);
    this.cpmService
      .viewFileInIFrame(
        `${environment.cpmBaseUrl}/download?type=crm_memo&id=${caseId}`
      )
      .then(ret => {
        this.iframeSource = this.sanitizer.bypassSecurityTrustResourceUrl(ret)
        this.closeModalWithFileTypeCondition(arrayContainsFileType)
      })
  }

  get isContinueCase(): Boolean {
    return this.caseStatus === 'C' ? true : false
  }

  get hasOldPresentationFileAtStart(): Boolean {
    return this.oldPresentationFile !== null ? true : false
  }

  get hasOldFactsheetFileAtStart(): Boolean {
    return this.oldFactsheetFile !== null ? true : false
  }

  get hasOldMemoFileAtStart(): Boolean {
    return this.oldMemoFile !== null ? true : false
  }

  get preparedSetAttendees(): Array<Object> {
    return this.setAttendees.map(x => {
      return (
        x['firstNameThai'] +
        ' ' +
        x['lastNameThai'] +
        ' - ' +
        x['positionName'] +
        ' - ' +
        x['departmentShortName']
      )
    })
  }

  get preparedCompanyAttendees(): Array<Object> {
    return this.companyAttendees.map(x => {
      return (
        x['firstName'] +
        ' ' +
        x['lastName'] +
        ' - ' +
        x['position'] +
        ' - ' +
        x['department']
      )
    })
  }

  scrollTo() {
    const elmnt = document.getElementById('outputCaseScroll')
    elmnt.scrollIntoView()
  }

  setSymbol(symbol) {
    if (!this.symbol) {
      this.showPage = true
    } else {
      this.showPage = this.symbol === symbol
    }
    this.symbol = symbol
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/output-case/output-case.component.ts